import Icon from '@dtvgo/icon';
import './CardNewProfile.scss';
import { jsxs, jsx } from 'react/jsx-runtime';

function CardNewProfile(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? 'Create Profile' : _ref$text,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/jsxs("div", {
    className: "dtv-common-c-card-new-profile ".concat(className),
    children: [/*#__PURE__*/jsx("div", {
      className: "dtv-common-c-card-new-profile__add",
      children: /*#__PURE__*/jsx(Icon, {
        className: "dtv-common-c-card-new-profile__logo",
        name: "add"
      })
    }), /*#__PURE__*/jsx("div", {
      className: "dtv-common-c-card-new-profile__name",
      children: text
    })]
  });
}

export { CardNewProfile as default };
//# sourceMappingURL=CardNewProfile.js.map
